import { render, staticRenderFns } from "./List.vue?vue&type=template&id=64c487d5&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c487d5')) {
      api.createRecord('64c487d5', component.options)
    } else {
      api.reload('64c487d5', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=64c487d5&", function () {
      api.rerender('64c487d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/area_plans/List.vue"
export default component.exports